import { getAllRolesInBoolean, getUserRoles } from 'src/mentor/layout/utils'

export default function useServerAuth() {
  const allRolesInBoolean = getAllRolesInBoolean()
  const allRoles = getUserRoles()
  return { allRolesInBoolean, allRoles }
}
